import React from 'react';

function SpaceBetweenCards() {
  return (
    <div style={{ height: '16px' }} />
  );
}

export default SpaceBetweenCards;
